import { GET_USER_RIGHTS_REQUEST, GET_USER_RIGHTS_SUCCESS, GET_USER_RIGHTS_ERROR } from "../actions/types"
export default function (state = null, action) {
    const { type, payload } = action;
    switch (type) {
        case GET_USER_RIGHTS_REQUEST:
            return {
                loading: true,
            };
        case GET_USER_RIGHTS_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_USER_RIGHTS_ERROR:
            return {
                ...state,
                loading: false
            };

        default:
            return state;
    }
}